/**
 * Routes the endpoints served by carbar-web-api (the Node listing service) to its own base URL.
 *
 * Only these three paths move; subscribe, check-availability, auth and everything else stay on
 * carbar-api (API_URL). When WEB_API_URL is empty every request goes to API_URL, which is how local
 * works (Caddy does the path split) and how any environment without the Node service works.
 */
const WEB_API_PATHS = [
	/^v2\/vehicles$/,
	/^v2\/vehicles\/[^/]+\/browse$/,
	/^v2\/order-requests$/,
]

export const isWebApiPath = (url) => {
	const path = String(url ?? '')
		.replace(/^\/+/, '')
		.split('?')[0]
		.replace(/\/+$/, '')

	return WEB_API_PATHS.some((pattern) => pattern.test(path))
}

/**
 * Base URL for the web API from this side of the request. In the browser it is the public value, normally the
 * relative `/api` that the Nitro proxy in server/api/v2 handles. During server-side rendering a relative base
 * cannot be fetched, so the server calls the proxy's own target directly and skips the hop.
 */
export const webApiBase = (runtimeConfig) => {
	if (import.meta.server && runtimeConfig.WEB_API_PROXY_TARGET) {
		return runtimeConfig.WEB_API_PROXY_TARGET
	}

	return runtimeConfig.public.WEB_API_URL
}

export const resolveApiBaseUrl = (url, { apiUrl, webApiUrl }) => {
	if (webApiUrl && isWebApiPath(url)) {
		return webApiUrl
	}

	return apiUrl
}
